import site_config      from "@/config"
import Logout           from "./components/Logout"
import Home             from "~/Home"
import NotFound         from "./components/NotFound"
import Redirect2Shop    from "./components/Redirect2Shop"
import OrerReset        from "./components/OrderReset"

import UseOtherBrowser  from "./components/UseOtherBrowser"

import Login            from "./components/account/Login"
import Welcome          from "./components/account/Welcome"
import ForgotPassword   from "./components/account/UserForgotPassword"
import ResetPassword    from "./components/account/UserResetPassword"
import Register         from "./components/account/Register"
import RegisterCompany  from "./components/account/RegisterCompany"

import ChangeParent     from "./components/company/ChangeParent"
import CreateCompany    from "./components/company/CreateCompany"
import CreateDelivery   from "./components/company/CreateDelivery"
import EditDelivery     from "./components/company/EditDelivery"
import OverviewDelivery from "./components/company/OverviewDelivery"
import MyCompany        from "./components/company/MyCompany"
import Companies        from "./components/company/Companies"
import ApproveOrder     from "./components/company/ApproveOrder"

import OverviewContacts from "./components/contact/OverviewContacts"
import CreateContact    from "./components/contact/CreateContact"
import EditContact      from "./components/contact/EditContact"
import SelectLine       from "./components/contact/SelectLine"
import ManageUsers      from  "./components/contact/ManageUsers"

import UploadFiles      from "./components/admin/UploadFiles"
import SwitchUser       from "./components/admin/SwitchUser"

import PriceLogs        from "./components/price/PriceLogs"
import DetailPrice      from "./components/price/DetailPrice"

import CatalogListView  from './views/CatalogListView.vue'
import CatalogView      from './views/CatalogView.vue'
import CategoryView     from './views/CategoryView.vue'
import ArticleView      from './views/ArticleView.vue'
import VartextView      from './views/VartextView.vue'

import TestLogin        from './views/TestLogin.vue'

function _beforeEnterHome (to, from, next) {
    if (localStorage.getItem ("useAs")) {
        next ({name: "redirect2shop"})
    }
    next ()
}
let routes = [
    {
        name: "home",
        path: "/:location?/home",
        alias: "/",
        component: Home,
        props: true,
        beforeEnter: _beforeEnterHome
    },
    {
        name: "welcome",
        path: "/:location?/welcome",
        component: Welcome,
        props: true
    },
    {
        name: "use-other-browser",
        path: "/use-other-browser",
        component: UseOtherBrowser,
    },
    {
        name: "password-forgot",
        path: "/:location?/forgot-password",
        component: ForgotPassword,
        props: true
    },
    {
        name: "password-reset",
        path: "/:location?/account/password/change/:token",
        component: ResetPassword,
        props: true,
    },
    {
        name: "login",
        path: "/:location?/login",
        component: Login,
        props: true
    },
    {
        name: "register-contact",
        path: "/:location?/register",
        component: Register,
        props: true
    },
    {
        name: "register-company",
        path: "/:location?/register-company/:token",
        component: RegisterCompany,
        props: true
    },
    {
        name: "my-company",
        path: "/my-company/",
        component: MyCompany,
        props: true,
        meta: { requiresAuth: true }
    },
    {
        name: "change-parent",
        path: "/change-parent/",
        component: ChangeParent,
        props: true,
        meta: { requiresAuth: true }
    },
    {
        name: "delivery-create",
        path: "/:location?/create-delivery/",
        component: CreateDelivery,
        props: true,
        meta: { requiresAuth: true },
    },
    {
        name: "delivery-overview",
        path: "/:location?/overview-delivery/",
        component: OverviewDelivery,
        props: true,
        meta: { requiresAuth: true }
    },
    {
        name: "delivery-edit",
        path: "/:location?/edit-delivery/",
        component: EditDelivery,
        props: router => ({
            address: router.query.address,
            redirect: router.query.redirect
        }),
        meta: { requiresAuth: true }
    },
    {
        name: 'redirect2shop',
        path: '/redirect2shop',
        component: Redirect2Shop
    },
    {
        name: "Logout",
        path: "/logout",
        component: Logout
    },
    {
        name: "testLogin",
        path: "/test-login",
        component: TestLogin
    },
    {
        name: "select-line",
        path: "/:location?/user/select-line/",
        component: SelectLine,
        props: true
    },
]

if (site_config.admin) {
    routes = routes.concat ([
        {
            name: "companies",
            path: "/companies/:cid",
            component: Companies,
            props: true,
            meta: { requiresAuth: true },
        },
        {
            name: "order-approve",
            path: "/order-approve/",
            component: ApproveOrder,
            props: true,
            meta: { requiresAuth: true },
        },
        {
            name: "order-reset",
            path: "/order-reset/",
            component: OrerReset,
            props: true,
            meta: { requiresAuth: true },
        },
        {
            name: "company-create",
            path: "/create-company/",
            component: CreateCompany,
            props: true,
            meta: { requiresAuth: true },
        },
        {
            name: "contacts-overview",
            path: "/overview-contacts/",
            component: OverviewContacts,
            props: true,
            meta: { requiresAuth: true },
        },
        {
            name: "contact-edit",
            path: "/edit-contact/:coid",
            component: EditContact,
            meta: { requiresAuth: true },
            props: true
        },
        {
            name: "contacts-create",
            path: "/create-contact/",
            component: CreateContact,
            props: true,
            meta: { requiresAuth: true },
        },
        {
            name: "files-upload",
            path: "/upload-files/",
            component: UploadFiles,
            meta: { requiresAuth: true },
            props: true,
        },
        {
            name: "switch-user",
            path: "/switch-user/",
            component: SwitchUser,
            meta: { requiresAuth: true },
            props: true,
        },
        {
            name: "price-overview",
            path: "/price-logs/",
            component: PriceLogs,
            props: true,
            meta: { requiresAuth: true },
        },
        {
            name: "price-detail",
            path: "/detail-price/:pid",
            component: DetailPrice,
            props: true,
            meta: { requiresAuth: true },
        },
        {
            name: "manage-users",
            path: "/manage-users/",
            component: ManageUsers,
            meta: { requiresAuth: true }
        },
        {   path: '/catalogs',
            name: 'catalog-list',
            component: CatalogListView
        },
        {   path: '/vartext',
            name: 'vartext',
            component: VartextView
        },
        {   path: '/catalog/:id',
            name: 'catalog',
            component: CatalogView,
        },
        {   path: '/catalog/:id/:path(.+)',
            name: 'category',
            component: CategoryView,
        },
        {   path: '/article/:id/:path(.+)',
            name: 'article',
            component: ArticleView,
        },
      ])
}
routes.push ({ path: "*", component: NotFound })

export default routes;
